import { ApiResponse } from 'app/types-shared';
import { CodeMetadataWire, CodesAccessWire, CodetablesAccessWire } from './types-store';
import { RemoteAdminData } from 'app/infrastructure/remote-data';
import { endpoints } from './endpoints';

export const api = {
  loadMetadata: async (id: number): Promise<CodeMetadataWire> => {
    const request = await new RemoteAdminData(endpoints.metadata(id))
      .resource<ApiResponse<CodeMetadataWire>>()
      .single();

    return request.data;
  },

  loadCodetablesAccess: async (codetableId: number): Promise<CodetablesAccessWire> => {
    const request = await new RemoteAdminData(endpoints.codetablesAccess)
      .resource<ApiResponse<CodetablesAccessWire>>()
      .filter({ id: codetableId })
      .single();
    return request.data;
  },

  loadCodesAccess: async (codetableId: number, codeId: number): Promise<CodesAccessWire> => {
    const request = await new RemoteAdminData(endpoints.codesAccess(codetableId))
      .resource<ApiResponse<CodesAccessWire>>()
      .filter({ id: codeId })
      .single();
    return request.data;
  }
};
